import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { useMediaQuery, Box, useTheme } from '@mui/material'

import { Footer } from './footer'
import { MainSection } from '../core/main-section'
import { LayoutSection } from '../core/layout-section'
import { HeaderSection } from '../core/header-section'
import Logo from '../../components/shared/logo/logo'
import ThemeSwitchButton from '../components/theme-switch-button'
import Button from '../../components/shared/button/Button'
import { LOG_IN_URL, SIGNUP_URL } from '../../constants/navigation'
import LogoShort from '../../components/shared/logo/logoShort'

// ----------------------------------------------------------------------

export function MainLayout({
  sx,
  cssVars,
  children,
  slotProps,
  layoutQuery = 'md'
}) {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const renderHeader = () => {
    const headerSlots = {
      leftArea: isMobile ? <LogoShort /> : <Logo />,
      rightArea: (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 1, sm: 1.5 }
            }}
          >
            <ThemeSwitchButton />

            <Button
              variant='outlined'
              label={t('login.log-in')}
              component={NavLink}
              to={LOG_IN_URL}
              color='primary'
            />
            <Button
              label={t('sign-up.sign-up')}
              component={NavLink}
              to={SIGNUP_URL}
              color='primary'
            />
          </Box>
        </>
      )
    }

    return (
      <HeaderSection
        layoutQuery={layoutQuery}
        {...slotProps?.header}
        slots={{ ...headerSlots, ...slotProps?.header?.slots }}
        slotProps={slotProps?.header?.slotProps}
        sx={slotProps?.header?.sx}
      />
    )
  }

  const renderFooter = () => (
    <Footer sx={slotProps?.footer?.sx} layoutQuery={layoutQuery} />
  )

  const renderMain = () => (
    <MainSection {...slotProps?.main}>{children}</MainSection>
  )

  return (
    <LayoutSection
      /** **************************************
       * @Header
       *************************************** */
      headerSection={renderHeader()}
      /** **************************************
       * @Footer
       *************************************** */
      footerSection={renderFooter()}
      /** **************************************
       * @Styles
       *************************************** */
      cssVars={cssVars}
      sx={sx}
    >
      {renderMain()}
    </LayoutSection>
  )
}
